



























import Vue from 'vue';
import { DialogViewModel } from '../../types';

export default Vue.extend({
    props: {
        component: { required: true },
        value: { default: false },
        title: { required: true },
        componentProps: {},
    },
    components: {},
    data(): DialogViewModel {
        return {
            isOpen: false,
        };
    },
    methods: {
        close() {
            this.isOpen = false;
            this.$emit('close');
        },
        save(e: any) {
            this.$emit('save', e);
            this.close();
        },
    },
    watch: {
        value: {
            handler: function (val) {
                this.isOpen = val;
                if (val) {
                    setTimeout(() => {
                        (this.$refs.editComponent as any).setNewItem();
                    });
                }
            },
        },
    },
});
